module.exports = __webpack_public_path__ + "img/point_thum2.a6483064.png";